// fire a callback when element has been focused
// but not when focused as a result of a mouse event
export function onTabFocus(element, callback) {
    let moused = false;
    function onMouseDown() {
        moused = true;
    }
    function onMouseUp() {
        moused = false;
    }
    function onFocus(e) {
        if (!moused) {
            callback(e);
        }
    }
    element.addEventListener('mousedown', onMouseDown);
    element.addEventListener('mouseup', onMouseUp);
    element.addEventListener('focus', onFocus);
    return {
        destroy() {
            element.removeEventListener('mousedown', onMouseDown);
            element.removeEventListener('mouseup', onMouseUp);
            element.removeEventListener('focus', onFocus);
        },
    };
}
